export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_village-gate/artifacts/agfphy4b_ChatGPT%20Image%20Sep%2027%2C%202026%2C%2011_47_19%20PM.png";

export const IMG = {
  host: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/cb2e50db8b8ffd63ddc85a8b98284b03102bf4500fb69bdc1982866d73691806.jpeg",
  gate: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/f5330fed357e3bf64acea877d18992b0c65375986a94f7b54230000d9349915a.jpeg",
  gate_dusk: "/village/gate-dusk.jpg",
  gate_night: "/village/gate-night.jpg",
  lane: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/f536e59c8c25c1a6c149cbe283667b9406c07155d65053bd97aa762c511b1126.jpeg",
  moncho: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/9cd26a698429744a6153cf72d2ebfe36a177bc625bc9898838b06754309dadf7.jpeg",
  shop: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/805457f2c51535c6efddf56d5ae4802b38726634d4bd487eeaa9d65344d7eecf.jpeg",
  scroll: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/3c18f638c2c697131ad059a503922b0b47934b34faa5e8ccfabf4595ca56028f.jpeg",
  horse: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/ba8b8b8b70149b49930279624b77c8b89428e2b32d5e0d0af511d0e907e6bad8.jpeg",
  saree: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/13e82f65b8bc63348484f8ba092f09b47a6be201e864324ea995ed2f7676eae6.jpeg",
  lamps: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/4f64850ee63028233772c193a30b5463ddb01dd8ad827f6c6deb5aced85357ab.jpeg",
  kantha: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/0ca48b3eccbe4f5454a9af5c643f25abf9007c403b42b2e9ed5cdfae21131b39.jpeg",
  pottery_shop: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/6b77f7a8a84264b34159f7ef4ea4f30ca01fac04b45bd1680cf9b47049564452.jpeg",
  pond: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/78dfdd1aead1059b989efddd64f56dd3868f74e9f55637bb846c8432c19cb20a.jpeg",
  handi: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/c163028eea57c29dc674a759c3caeafe4127c2554770777a21542719ed7345e1.jpeg",
  surai: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/c8fdff0c132af9b412f6c09629ec0777f255f58719002d60007820a94d24497c.jpeg",
  planters: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/f5bfca837ac3bd43865c4f410d03ccd4638b833e833a7b5e705ce39aa109649b.jpeg",
  figures: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/c1e083b56fa10ed979f4f238840efd363a93ee32c83b4f41e271e3e29a028336.jpeg",
  baul_portrait: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/559de90f724d3d34f851825828a79653b035d6874fa32430364b635b3006473d.jpeg",
  figure: "https://static.prod-images.emergentagent.com/jobs/dae932cb-8812-4dd2-af14-877696a6ffce/images/9a3bf9c2cd8db43fb722503664cb26d2e0cd174a0ecc1b8d3d6afb27f00b3d17.jpeg",
};

export const PRODUCTS = [
  {
    id: "p1",
    title: "কৃষ্ণলীলা পটচিত্র চিত্রপট",
    latin: "Krishna-leela Pata Scroll",
    price: "₹ ৪,৫০০",
    artisan: "গুরুপদ চিত্রকর • পিংলা, মেদিনীপুর",
    img: IMG.scroll,
    tag: "হাতে আঁকা গল্প",
  },
  {
    id: "p2",
    title: "বাঁকুড়ার টেরাকোটা ঘোড়া — জোড়া",
    latin: "Bankura Terracotta Horses",
    price: "₹ ১,৮০০",
    artisan: "পাঁচমুড়া মৃৎশিল্পী দল • বাঁকুড়া",
    img: IMG.horse,
    tag: "মাটিতে হাতে গড়া",
  },
  {
    id: "p3",
    title: "লালপাড় তাঁত শাড়ি",
    latin: "Handloom Tant Saree",
    price: "₹ ২,৬০০",
    artisan: "শান্তিপুরের তাঁতি • নদিয়া",
    img: IMG.saree,
    tag: "হাতে বোনা",
  },
  {
    id: "p4",
    title: "মাটির প্রদীপের সেট",
    latin: "Clay Lamp Set",
    price: "₹ ৩৫০",
    artisan: "কুমারপাড়ার মৃৎশিল্পী • ময়নাগড়",
    img: IMG.lamps,
    tag: "আগুনে পোড়ানো",
  },
  {
    id: "p5",
    title: "কাঁথাসেলাই রানার",
    latin: "Kantha-stitch Runner",
    price: "₹ ২,২০০",
    artisan: "বীরভূমের কাঁথাশিল্পী দল",
    img: IMG.kantha,
    tag: "সুচের আঁচড়ে গল্প",
  },
];

export const BAUL_SONG_URL =
  "https://archive.org/download/dni.ncaa.CCRT-336-SP/CCRT-336-SP_SIDE_A.mp3";

export const BAUL_INVITATION =
  "নমস্কার বন্ধু। আজ সন্ধ্যায় বটতলায় আমার আসর — একতারা হাতে বসে আছি। প্রদীপ জ্বলবে, গান হবে। চলে এসো।";

export const HOST_LINES = {
  hat: {
    text: "এই পথের দু'ধারে শিল্পীদের ঘর — পটচিত্র ঘর আর মৃৎশিল্পের ঘর, দুটোই আজ খোলা।",
    chips: [
      { view: "shop", shop: "potchitra", label: "পটচিত্র ঘরে যাই" },
      { view: "shop", shop: "mrityo", label: "মৃৎশিল্পের ঘরে যাই" },
      { view: "moncho", label: "রং ও মঞ্চে যাই" },
    ],
  },
  shop: {
    text: "সব শিল্পকর্ম সরাসরি শিল্পীদের হাত থেকে আসে। পছন্দ হলে হৃদয়-চিহ্নে চেপে থলিতে জমিয়ে রাখুন।",
    chips: [
      { view: "hat", label: "রঙের হাটে ফিরে যাই" },
      { view: "moncho", label: "রং ও মঞ্চে যাই" },
    ],
  },
  moncho: {
    text: "আপনি শুধু গান শুনতে এসেছেন, নাকি আপনার অনুষ্ঠানের জন্য একজন শিল্পী খুঁজছেন?",
    chips: [
      { label: "শুনতে চাই", action: "listen", send: "আমি শুধু গান শুনতে এসেছি" },
      { label: "আমার অনুষ্ঠানের জন্য শিল্পী বুক করতে চাই", action: "book", send: "আমার অনুষ্ঠানের জন্য শিল্পী বুক করতে চাই" },
    ],
  },
};

export const WELCOME_LINES = [
  "নমস্কার। রং ও মাটিতে আপনাকে স্বাগতম।",
  "আজ কোথায় যাবেন?",
  "রং ও মঞ্চে, নাকি রঙের হাটে?",
];

export const WELCOME_LINES_EVENING = [
  "শুভ সন্ধ্যা। সন্ধ্যা নামলেই আমাদের গ্রামে প্রদীপ জ্বলে।",
  "আপনার আগমনেই আজ পথের ধারে আলো ফুটল।",
  "রঙের হাটে যাবেন, নাকি রং ও মঞ্চে?",
];

export const VOICE_WELCOME =
  "নমস্কার। রং ও মাটিতে আপনাকে স্বাগতম। আজ কোথায় যাবেন? রং ও মঞ্চে, নাকি রঙের হাটে?";

export const VOICE_WELCOME_EVENING =
  "শুভ সন্ধ্যা। সন্ধ্যা নামলেই আমাদের গ্রামে প্রদীপ জ্বলে। আজ কোথায় যাবেন? রঙের হাটে, নাকি রং ও মঞ্চে?";

export const MRITYO_PRODUCTS = [
  {
    id: "m1",
    title: "মাটির হাঁড়ি-হান্দির সেট",
    latin: "Clay Handi Pot Set",
    price: "₹ ৬৫০",
    artisan: "কুমারপাড়ার কুমার পরিবার • মেদিনীপুর",
    img: IMG.handi,
    tag: "আগুনে পোড়ানো",
  },
  {
    id: "m2",
    title: "জলের সুরাই",
    latin: "Clay Water Pitcher",
    price: "₹ ৯০০",
    artisan: "ময়নাগড়ের মৃৎশিল্পী",
    img: IMG.surai,
    tag: "ঠান্ডা জলের বন্ধু",
  },
  {
    id: "m3",
    title: "ফোক-নকশার চারা টব — সেট",
    latin: "Folk-carved Planters",
    price: "₹ ৭৫০",
    artisan: "কুমারপাড়ার মৃৎশিল্পী দল",
    img: IMG.planters,
    tag: "উঠানে সবুজের ঘর",
  },
  {
    id: "m4",
    title: "মাটির পুতুল — গ্রামের মানুষ",
    latin: "Hand-modelled Clay Dolls",
    price: "₹ ৫৫০",
    artisan: "দক্ষিণবাংলার মৃৎপুতুল শিল্পী",
    img: IMG.figures,
    tag: "হাতে গড়া গল্প",
  },
];

export const SHOPS = {
  potchitra: {
    id: "potchitra",
    name: "পটচিত্র ঘর",
    latin: "THE SCROLL-PAINTERS' HOUSE",
    img: IMG.shop,
    blurb:
      "মেদিনীপুরের পটুয়ারা এখানে নিজের হাতে আঁকা চিত্রপট রাখেন — প্রতিটি রেখায় গ্রামের গল্প।",
    products: PRODUCTS,
  },
  mrityo: {
    id: "mrityo",
    name: "মৃৎশিল্পের ঘর",
    latin: "THE POTTERS' HOUSE",
    img: IMG.pottery_shop,
    blurb:
      "কুমারপাড়ার কুমারদের উঠান — চাক ঘোরে, মাটি গড়ায়, হাঁড়ি-হান্দি আগুনে পোড়ে।",
    products: MRITYO_PRODUCTS,
  },
};

/* পটচিত্র ঘরের নতুন ঘরানা — হাতে-আঁকা পাঞ্জাবি + পট/কাঁথা (দোকান চালু হলে /api/site থেকে আসে) */
export const POT_FALLBACK = [
  {
    id: "pn1", shop_key: "potchitra", title: "হাতে-আঁকা পাঞ্জাবি — ময়ূরপঙ্খি", latin: "Hand-painted Panjabi 01",
    price: "₹ ১,৯৯৯", price_num: 1999, min_price: 1750,
    artisan: "চিত্রা চিত্রকর • পিংলা, মেদিনীপুর", img: "/api/media/shop/panjabi1.jpg",
    tag: "পটচিত্রে হাতে আঁকা", craft: "পটচিত্র হাতে-আঁকা, সিল্ক-সুতি", colour: "ক্রেমে, পোড়ামাটি লাল মোটিফ",
    sizes: ["স", "এম", "এল", "এক্সএল"], material: "সিল্ক-সুতি, জলরঙ",
    story: "পিংলার পটুয়ারা বলেন — ময়ূরের পালক আনন্দের খবর নিয়ে আসে। কলার, প্ল্যাকেট আর আঁচল-পাড়ে প্রতিটি মোটিফ হাতে, জলরঙে আঁকা।",
    custom_order: true, delivery: "৫-৭ দিনে পুরো বাংলায় কুরিয়ার।", tryon: true,
  },
  {
    id: "pn2", shop_key: "potchitra", title: "হাতে-আঁকা পাঞ্জাবি — পাল-গল্প", latin: "Hand-painted Panjabi 02",
    price: "₹ ২,৩৫০", price_num: 2350, min_price: 1950,
    artisan: "গুরুপদ চিত্রকরের দল • পিংলা, মেদিনীপুর", img: "/api/media/shop/panjabi2.jpg",
    tag: "পটচিত্রে হাতে আঁকা", craft: "পটচিত্র হাতে-আঁকা, রঙাজল", colour: "নীল, সাদা পাল-চিত্র",
    sizes: ["এম", "এল", "এক্সএল"], material: "রঙাজল সুতি, জলরঙ",
    story: "চিত্রপটের পাল-গল্প এবার পেটে-বুকে হাঁটে — সাদা রেখায় বাঁকা পটুয়া-ফিগার, যেন গায়ে পরলেই গল্প বলা হয়।",
    custom_order: true, delivery: "৫-৭ দিনে পুরো বাংলায় কুরিয়ার।", tryon: true,
  },
  {
    id: "pn3", shop_key: "potchitra", title: "হাতে-আঁকা পাঞ্জাবি — আলপনা রেখা", latin: "Hand-painted Panjabi 03",
    price: "₹ ১,৬৫০", price_num: 1650, min_price: 1400,
    artisan: "চিত্রা চিত্রকর • পিংলা, মেদিনীপুর", img: "/api/media/shop/panjabi3.jpg",
    tag: "আলপনা হাতে আঁকা", craft: "আলপনা মোটিফ হাতে-আঁকা, সিল্ক-সুতি", colour: "সাদা, সিঁদুর লাল রেখা",
    sizes: ["স", "এম", "এল"], material: "সিল্ক-সুতি, জলরঙ",
    story: "শুভর আলপনা-রেখা বুকে ছড়ানো — ছোট-বড় অনুষ্ঠানের জন্য পটুয়াদের সবচেয়ে মিষ্টি ঘরানা।",
    custom_order: true, delivery: "৫-৭ দিনে পুরো বাংলায় কুরিয়ার।", tryon: true,
  },
  { ...PRODUCTS[0], story: "কৃষ্ণলীলার আখ্যান হাতকাগজে — প্যাটার গানের মতো ছবিটাও পাল ধরে পাল ধরে বলে।", craft: "পটচিত্র হাতে-আঁকা চিত্রপট", colour: "পোড়ামাটি ও নীল", sizes: ["একক পিস"], material: "হাতকাগজ, জলরঙ", price_num: 4500, min_price: 3600, tryon: false },
  { ...PRODUCTS[4], story: "বীরভূমের দিদিমণিদের হাতে সূচ-ফোঁড়ে গ্রামের দিনলিপি — প্রতিটি আঁচড়ে একটা গল্প।", craft: "কাঁথাসেলাই সূচ-কারুকাজ", colour: "মাটির বেগুনি, সর্ষপ-হলুদ", sizes: ["একক পিস"], material: "সুতি, সূচ ও সুতো", price_num: 2200, min_price: 1800, tryon: false },
];

export const ALL_PRODUCTS = Object.values(
  // পটচিত্র ঘরের নতুন পণ্য আগে — একই আইডি হলে নতুন ঘরানার তথ্যই থাকবে
  Object.fromEntries([...POT_FALLBACK, ...PRODUCTS, ...MRITYO_PRODUCTS].map((p) => [p.id, p])),
);

/* রং ও মঞ্চ — শিল্পী-ফলব্যাক (সত্যিকারের তথ্য /api/moncho/artists থেকে আসে) */
export const ARTISTS_FALLBACK = [
  {
    id: "sanatan",
    name: "সনাতন দাস বাউল",
    art_form: "বাউল ও লোকসঙ্গীত",
    location: "নদিয়া, বাংলা",
    languages: ["বাংলা", "হিন্দি"],
    story:
      "নদিয়ার মাটিতে জন্ম, বাবা-দাদা দুজনেই ভাটিয়ালি-বাউল গেয়েছেন। সনাতন দাসের একতারায় লালন-শাহের গান মিশে আছে নদিয়ার নদীর স্রোতের সঙ্গে। বিয়ে, পুজো, গ্রামের মেলা — যেখানেই গেছেন, শ্রোতারা বলেছে এক কথায়: গানে ভেতরটা ভিজে যায়। পরিবেশনা মানে তাঁর কাছে মঞ্চ নয় — মাটিতে বসে, প্রদীপের আলোয়, মানুষের মুখে মুখ রেখেই গান।",
    price_start: 9500,
    price_display: "₹ ৯,৫০০ থেকে",
    price_range: "₹৯,৫০০ – ₹২৫,০০০",
    quote: 9500,
    img: "/api/media/moncho/courtyard.jpg",
    profile_img: IMG.baul_portrait,
    photos: [IMG.baul_portrait, IMG.moncho, "/api/media/moncho/courtyard.jpg"],
    audio: BAUL_SONG_URL,
    audio_note: "তাঁর ঘরানার বাউলগান — উন্মুক্ত সংগ্রহ (archive.org)",
    showreel_text: BAUL_INVITATION,
    notice_days: 3,
    unavailable_dates: [],
    performer_match: "সনাতন দাস বাউল",
  },
  {
    id: "radhanagar",
    name: "রাধানগর লোকনৃত্য দল",
    art_form: "চৌ নৃত্য",
    location: "পুরুলিয়া, বাংলা",
    languages: ["বাংলা"],
    story:
      "পুরুলিয়ার রাধানগরের চৌ-নর্তকরা প্রজন্মের পর প্রজন্মে মুখোশ আর ঢাকের তালে দেবাসুরের নৃত্য নাচেন। আঠারো জনের দল — বড় মুখোশ, ঝলমলে পোশাক, ঢাক-ঢোলের সুরে উঠান কাঁপানো খাঁটি চৌ। স্কুলের বার্ষিক সভা, মেলা, কর্পোরেট-সন্ধ্যা — বড় উঠান-ময়দানে তাঁদের নাচ সবচেয়ে ভরা পেটেও হাওয়া করে দেয়।",
    price_start: 15000,
    price_display: "₹ ১৫,০০০ থেকে",
    price_range: "₹১৫,০০০ – ₹৪০,০০০",
    quote: 15000,
    img: "/api/media/moncho/chhau.jpg",
    profile_img: "/api/media/moncho/chhau.jpg",
    photos: ["/api/media/moncho/chhau.jpg"],
    audio: "",
    audio_note: "",
    showreel_text: "",
    notice_days: 5,
    unavailable_dates: [],
    performer_match: "রাধানগর লোকনৃত্য দল",
  },
];

export const MARQUEE_ITEMS = [
  "পটচিত্র",
  "বাউলগান",
  "টেরাকোটা",
  "কাঁথাসেলাই",
  "তাঁতশাড়ি",
  "মাটির প্রদীপ",
  "লোকনৃত্য",
  "মৃৎশিল্প",
];
